import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, Typography, withTypography } from 'components/ui';
import type { BoxProps, TypographyProps } from 'components/ui';
import { getDesignToken, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  group: {
    backgroundColor: getDesignToken('background-card'),
    marginBottom: spacing.$2,
  },
  headerWrapper: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: spacing.$6,
    paddingBottom: spacing.$2,
    paddingHorizontal: spacing.$4,
  },
  footer: {
    alignItems: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#dcdcdc',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: spacing.$10,
    paddingHorizontal: spacing.$4,
    paddingVertical: spacing.$1,
  },
  headerText: {
    flex: 1,
  },
});

export const Group = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.group, style],
  });

export const HeaderWrapper = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.headerWrapper, style],
  });

export const HeaderText = ({
  $isNested,
  style,
  ...props
}: TypographyProps & { $isNested?: boolean }) =>
  React.createElement(Typography, {
    ...props,
    variant: $isNested ? 'headerFour' : 'headerThree',
    m: '$0',
    // Variants `headerThree`/`headerFour` bake in `mb: 3` (= 12dp). The `m` shorthand
    // above expands to longhand margins, and this keeps the heading tight against its container.
    mb: '$0',
    pr: '$2',
    style: [styles.headerText, style],
  });

export const SubHeaderText = withTypography({
  variant: 'copyTwo',
  px: '$1',
  style: { paddingVertical: 1, marginTop: -2, marginBottom: 0 },
});

export const Footer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.footer, style],
  });
